var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13V16C3.5 17.0609 3.92143 18.0783 4.67157 18.8284C5.42172 19.5786 6.43913 20 7.5 20H17.5C18.5609 20 19.5783 19.5786 20.3284 18.8284C21.0786 18.0783 21.5 17.0609 21.5 16V13.6C21.5 13.4409 21.4368 13.2883 21.3243 13.1757C21.2117 13.0632 21.0591 13 20.9 13H3.5ZM3.5 13V7C3.5 5.93913 3.92143 4.92172 4.67157 4.17157C5.42172 3.42143 6.43913 3 7.5 3H12.5M8.5 20L7.5 22M16.5 20L17.5 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09998 8H15.9C16.231 8 16.496 7.732 16.46 7.402C16.314 6.075 15.637 3 12.5 3C9.36298 3 8.68598 6.075 8.53998 7.402C8.50398 7.732 8.76898 8 9.09998 8Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.0fcd4c1cc7d8c8dc3423972026e43cbb.svg";
export { ForwardRef as ReactComponent };